import { render, staticRenderFns } from "./UseStatistics.vue?vue&type=template&id=61236e6a&scoped=true"
import script from "./UseStatistics.vue?vue&type=script&lang=js"
export * from "./UseStatistics.vue?vue&type=script&lang=js"
import style0 from "./UseStatistics.vue?vue&type=style&index=0&id=61236e6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61236e6a",
  null
  
)

export default component.exports